import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=66a020e1&scoped=true"
import script from "./ReturnDialog.vue?vue&type=script&lang=js"
export * from "./ReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./ReturnDialog.vue?vue&type=style&index=0&id=66a020e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a020e1",
  null
  
)

export default component.exports